import {
  ConsignmentApiModel,
  ConsignmentParcelItemApiModel,
  Dimensions,
  SmartSendItemApiModel
} from '~/lib/api/smartsend/types';
import { SumNumber, onlyUnique } from '../../../../lib/helpers/ArrayHelper';
import { uid } from '../../../../lib/helpers/uid';
import { QuantityValueSummary } from '../QuantityValueSummary';

export function GetConsignmentFromItem(item: SmartSendItemApiModel): ConsignmentApiModel {
  if (item.Consignment) {
    AddIdsToConsignment(item.Consignment);
    return item.Consignment;
  }

  return null;
}

export function SanitiseConsignmentForSave(item: SmartSendItemApiModel) {
  if (item.Consignment?.Parcels?.length > 0) {
    ConsolidateParcelQuantities(item.Consignment);
    if (JSON.stringify(item.Consignment).length > 2400) {
      item.Consignment = null;
    }
  }
}

function generateKey(o: ConsignmentParcelItemApiModel): string {
  return `${o.Id}|${o.Description}`;
}

export function ConsolidateParcelQuantities(c: ConsignmentApiModel) {
  c.Parcels.forEach((p) => {
    const newOrders: ConsignmentParcelItemApiModel[] = [];

    // Group by id, and any override descriptions the user might have entered
    p.Contents.map(generateKey)
      .filter(onlyUnique)
      .forEach((key) => {
        const list = p.Contents.filter((x) => generateKey(x) === key);
        const value = SumNumber(list.map((l) => l.Value));
        const qty = SumNumber(list.map((l) => l.Quantity));
        newOrders.push({ ...list[0], Quantity: qty, Value: value });
      });

    p.Contents = newOrders;
  });
}

export function SplitConsignmentWeight(d: Dimensions, c: ConsignmentApiModel): ConsignmentApiModel {
  if (!c || !d?.Weight) {
    return c;
  }

  const s = QuantityValueSummary(d.Weight, c.Parcels.length);
  c.Parcels.forEach((p, i) => {
    p.Dimensions.Weight = i == 0 ? s.valueForFirstItem : s.valueForOtherItems;
  });

  return c;
}

export function AddIdsToConsignment(c: ConsignmentApiModel) {
  c.Parcels.forEach((p) => {
    p.UID = uid();
    p.Contents.forEach((o) => {
      o.UID = uid();
    });
  });
}
